
import React, { useState } from "react";

import { db } from "../../firebase";

import {
  collection,
  getDocs,
  query,
  orderBy,
} from "firebase/firestore";

import * as XLSX from "xlsx";

function ExportExcel() {

  const [loading, setLoading] = useState(false);

  const exportToExcel = async () => {

    try {
      setLoading(true);

      // Fetch All Firestore Data
      const q = query(
        collection(db, "teacher_application_data"),
        orderBy("createdAt", "desc")
      );

      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        alert("No Application Data Found!");
        return;
      }

      // Convert Firestore Data to Excel Rows
      const excelData = querySnapshot.docs.map(
        (doc, index) => {

          const data = doc.data();

          return {
            "SL NO": index + 1,

            "APPLICATION ID": doc.id,

            "NAME OF APPLICANT":
              data.applicantName || "",

            "FATHER'S NAME":
              data.fatherName || "",

            "MOTHER'S NAME":
              data.motherName || "",

            "GUARDIAN'S NAME":
              data.guardianName || "",

            "DATE OF BIRTH":
              data.dob || "",

            "CONTACT NO.":
              data.contactNo || "",

            "AADHAR NO.":
              data.aadharNo || "",

            "GENDER":
              data.gender || "",

            "CATEGORY":
              data.category || "",

            "E-MAIL":
              data.email || "",

            "RELIGION":
              data.religion || "",

            "HS BOARD NAME":
              data.hsBoard || "",

            "ADDRESS":
              data.address || "",

            "HS SUBJECT":
              data.hsSubject || "",

            "TOTAL MARKS HS":
              data.totalMarks || "",

            "MARKS OBTAINED":
              data.marksObtained || "",

            "PHOTO URL":
              data.photoURL || "",

            "SIGNATURE URL":
              data.signatureURL || "",

            "AADHAR CARD URL":
              data.aadharURL || "",

            "HS MARKSHEET URL":
              data.hsMarksheetURL || "",

            "APPLICATION STATUS":
              data.applicationStatus || "",

            "SUBMISSION DATE":
              data.createdAt?.toDate
                ? data.createdAt.toDate().toLocaleString("en-IN")
                : "",
          };
        }
      );

      // Create Excel Workbook
      const worksheet = XLSX.utils.json_to_sheet(
        excelData
      );

      // Set Column Width
      worksheet["!cols"] = [
        { wch: 8 },
        { wch: 30 },
        { wch: 25 },
        { wch: 25 },
        { wch: 25 },
        { wch: 25 },
        { wch: 15 },
        { wch: 15 },
        { wch: 18 },
        { wch: 12 },
        { wch: 15 },
        { wch: 30 },
        { wch: 18 },
        { wch: 20 },
        { wch: 35 },
        { wch: 25 },
        { wch: 15 },
        { wch: 15 },
        { wch: 40 },
        { wch: 40 },
        { wch: 40 },
        { wch: 40 },
        { wch: 20 },
        { wch: 25 },
      ];

      // Create Workbook
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Teacher Applications"
      );

      // Download Excel File
      XLSX.writeFile(
        workbook,
        `Teacher_Applications_${new Date()
          .toISOString()
          .slice(0, 10)}.xlsx`
      );

      alert(
        `Successfully Exported ${excelData.length} Applications!`
      );

    } catch (error) {

      console.error("Excel Export Error:", error);

      alert("Excel Download Failed!");

    } finally {

      setLoading(false);

    }
  };

  return (
    <div className="container my-3">

      <div className="card shadow p-4">

        <h4 className="text-primary text-center mb-3">
          Student Application Management
        </h4>

        <button
          type="button"
          className="btn btn-success w-100"
          onClick={exportToExcel}
          disabled={loading}
        >

          {loading
            ? "Please Wait, Exporting Data..."
            : "Download All Applications Excel"}

        </button>

      </div>

    </div>
  );
}

export default ExportExcel;